var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 2.66675C6.5265 2.66675 5.33317 3.86008 5.33317 5.33341C5.33317 6.80675 6.5265 8.00008 7.99984 8.00008C9.47317 8.00008 10.6665 6.80675 10.6665 5.33341C10.6665 3.86008 9.47317 2.66675 7.99984 2.66675ZM9.33317 5.33341C9.33317 4.60008 8.73317 4.00008 7.99984 4.00008C7.2665 4.00008 6.6665 4.60008 6.6665 5.33341C6.6665 6.06675 7.2665 6.66675 7.99984 6.66675C8.73317 6.66675 9.33317 6.06675 9.33317 5.33341ZM11.9998 11.3334C11.8665 10.8601 9.79984 10.0001 7.99984 10.0001C6.19984 10.0001 4.13317 10.8601 3.99984 11.3401V12.0001H11.9998V11.3334ZM2.6665 11.3334C2.6665 9.56008 6.21984 8.66675 7.99984 8.66675C9.77984 8.66675 13.3332 9.56008 13.3332 11.3334V13.3334H2.6665V11.3334Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHost);
export default __webpack_public_path__ + "static/media/Host.9dfe7a290594421d94281d51f46f446d.svg";
export { ForwardRef as ReactComponent };